import { Truck, PackageCheck, Building2, Home as HomeIcon, Zap, ClipboardList } from "lucide-react";

export const services = [
  {
    icon: Truck, title: "Local & Regional Freight",
    desc: "Reliable freight transportation across the region and nationwide.",
    img: "https://images.unsplash.com/photo-1592838064575-70ed626d3a0e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHw0fHxsb2dpc3RpY3MlMjBib3glMjB0cnVjayUyMGhpZ2h3YXl8ZW58MHx8fHwxNzgyODY1ODgwfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    icon: PackageCheck, title: "Last-Mile Delivery",
    desc: "Fast, professional delivery for retailers, warehouses, and distributors.",
    img: "https://customer-assets.emergentagent.com/job_laronta-logistics/artifacts/d73slfn7_semi-semitrailer-truck-tractor-highway.webp",
  },
  {
    icon: Building2, title: "Commercial Deliveries",
    desc: "Scheduled and on-demand transportation tailored for businesses.",
    img: "https://customer-assets.emergentagent.com/job_laronta-logistics/artifacts/fq58hbjp_truck-rental-list-sharerig-semi-truck-jpeg.webp",
  },
  {
    icon: HomeIcon, title: "Residential Deliveries",
    desc: "Safe delivery of furniture, appliances, and oversized items.",
    img: "https://customer-assets.emergentagent.com/job_laronta-logistics/artifacts/toaunktd_IMG_0707.JPG",
  },
  {
    icon: Zap, title: "Expedited Freight",
    desc: "Time-sensitive shipments delivered quickly and professionally.",
    img: "https://images.unsplash.com/photo-1616432043562-3671ea2e5242?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxsb2dpc3RpY3MlMjBib3glMjB0cnVjayUyMGhpZ2h3YXl8ZW58MHx8fHwxNzgyODY1ODgwfDA&ixlib=rb-4.1.0&q=85",
  },
  {
    icon: ClipboardList, title: "Contract Delivery",
    desc: "Long-term dedicated transportation solutions for your business.",
    img: "https://customer-assets.emergentagent.com/job_laronta-logistics/artifacts/5ju3xf9o_ChatGPT%20Image%20Jul%201%2C%202026%2C%2002_44_31%20AM.png",
  },
];

export const SERVICE_TYPES = [
  "Local & Regional Freight", "Last-Mile Delivery", "Commercial Deliveries",
  "Residential Deliveries", "Expedited Freight", "Contract Delivery",
];

export const SHIPMENT_STATUSES = [
  { key: "pending", label: "Pending" },
  { key: "picked_up", label: "Picked Up" },
  { key: "in_transit", label: "In Transit" },
  { key: "out_for_delivery", label: "Out for Delivery" },
  { key: "delivered", label: "Delivered" },
];

export const SHIPMENT_STATUS_LABELS = Object.fromEntries(SHIPMENT_STATUSES.map((s) => [s.key, s.label]));

export const QUOTE_STATUSES = ["new", "contacted", "quoted", "closed"];

export const CAREER_STATUSES = ["new", "under_review", "interview", "hired", "rejected"];
